import React from "react"
import { RichText } from "../common/rich-text.component"
import { getLinkClass } from "../../utils/styles"
import { CustomLink } from "../common/custom-link.component"
import { Section } from "../section.component"
import { ShippingCalculator } from "../shiping-calculator.component"


export const ShippingCalculatorSlice = ({ slice, large }) => {
  const bgImage = slice.primary && slice.primary.bg_image
  const bgColor = slice.primary && slice.primary.bg_color
  const minHeight = slice.primary && slice.primary.min_height
  return (
    <Section className={`d-flex align-items-center ${slice.label}`} backgroundImage={bgImage} backgroundColor={bgColor} large={large} minHeight={minHeight}>
      {(()=>{
        switch (slice.label) {
          case 'content-right':
            return  (
              <div className="row align-items-center">
                <div className="col-xs-12 col-md-6">
                  <ShippingCalculator params={slice.primary}/>
                </div>
                <div className="col-xs-12 col-md-6">
                  <div className="mb25">
                    <RichText render={slice.primary.title}/>
                  </div>
                  <div className="mb25">
                    <RichText render={slice.primary.text}/>
                  </div>
                  <CustomLink
                    link={slice.primary.link}
                    className={getLinkClass(slice.primary.link_style, "link")}>
                    {slice.primary.link_text}
                  </CustomLink>
                </div>
              </div>
            )
          case 'content-left':
            return (
              <div className="row align-items-center">
                <div className="col-xs-12 col-md-6">
                  <div className="mb30">
                    <RichText render={slice.primary.title}/>
                  </div>
                  <div className="mb25">
                  <RichText render={slice.primary.text}/>
                  </div>
                  <CustomLink
                    link={slice.primary.link}
                    className={getLinkClass(slice.primary.link_style, "link")}>
                    {slice.primary.link_text}
                  </CustomLink>
                </div>
                <div className="col-xs-12 col-md-6">
                  <ShippingCalculator params={slice.primary}/>
                </div>
              </div>
            )
          default:
            return (
              <div className="block-with-image-block text-center">
                <div className="mb25">
                  <div className="mb30">
                    <RichText render={slice.primary.title}/>
                  </div>
                  <div className="mb25">
                  <RichText render={slice.primary.text}/>
                  </div>
                </div>
                <div className="mx-auto mb-5">
                  <ShippingCalculator params={slice.primary}/>
                </div>
                <div className="mt50">
                  <CustomLink
                    link={slice.primary.link}
                    className={getLinkClass(slice.primary.link_style, "link")}>
                    {slice.primary.link_text}
                  </CustomLink>
                </div>
              </div>
            )
        }

      })()}

    </Section>
  )
}
